
import { Component, Inject, OnDestroy, OnInit, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import * as _ from 'underscore';
declare const clevertap;


@Component({
    selector: 'app-ai-sourcing-archive',
    templateUrl: './ai-sourcing-archive.component.html',
    styleUrls: ['./ai-sourcing-archive.component.scss'],
    standalone: false
})
export class AiSourcingArchiveComponent implements OnInit, OnDestroy {
  archivedProfiles: any[] = [];
  projectNumber: string;
  tabType: string = 'autopilotTab';
  currentCandidate: any;
  currentIndex: number;
  showCandidate: boolean = false;
  viewMoreSkills: boolean = false;
  subscriptions: Array<Subscription> = [];
  successMessage: string = '';
  errorMessage: string = '';
  selectedCandididate: any[] = [];
  showLoaderbeforeDataLoad: boolean = false;
  projectDetails: any;
  showShortlistRevaluate: string = '';
  showArchiveRevaluate: string = '';
  totalCandidatesCount: number = 0;
  currentPage: number = 1;
  blur: boolean = false;
  doNotshowArchivePage: boolean = false;
  reviewpageAccessBlocked: boolean = false;

  constructor(
    private personSearchService: PersonSearchService,
    private aggregationService: AggregationService,
    private aiSourcingService: AiSourcingService,
    private filterDataHandlerService: FilterDataHandlerService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private localStorageService: LocalStorageService,
    @Inject(DOCUMENT) private document: Document, private router: Router,
  ) {

    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      if (this.router.url.includes('ai-sourcing-profiles/archive')) {
        if (_methodDetails.methodName == 'clearFilters') {
          if (_methodDetails.source && _methodDetails.source == 'tabChange') {
            return;
          } else {
            this.getArchivedProfiles();
          }
        } else { // custom fla
          this.getArchivedProfiles();
        }
      }
    });
    this.subscriptions.push(filterMethodEvent);

  }

  ngOnInit() {
    this.projectNumber = window.location.pathname?.split('/')[4];
    this.getArchivedProfiles();
    const getSelectedAllCandidateEvent = this.aiSourcingService.getSelectAllCandidateEvent.subscribe(res => {
      if (res?.clearAll) {
        this.selectedCandididate = [];
        const selectedIds = new Set(this.selectedCandididate.map((c: any) => c.id));
        this.archivedProfiles = (this.archivedProfiles).map((candidate: any) => ({
          ...candidate,
          selected: selectedIds.has(candidate.id)
        }));
      } else if (res?.tab == 'archieved') {
        this.bulkSelectCandidate(res);
      }
    });
    this.subscriptions.push(getSelectedAllCandidateEvent);
    const refreshListEvent = this.aiSourcingService.getRefreshListEvent.subscribe(res => { this.refreshList(res) });
    this.subscriptions.push(refreshListEvent);
    this.projectDetails = this.aiSourcingHandlerService.fetchProjectDetails;
    setTimeout(() => {
      const filterRow = document.querySelector<HTMLElement>("#topArchive");
      if (filterRow) {
        const y = filterRow.getBoundingClientRect().top + window.scrollY - 500;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 0);
  }

  getArchivedProfiles() {
    this.showLoaderbeforeDataLoad = true;
    this.doNotshowArchivePage = false;
    const requestObject = this.aggregationService.getRequestWithFilters();
    requestObject['candidatetype'] = 'archive';
    requestObject['pagesize'] = 20;
    requestObject['page'] = this.currentPage;
    requestObject.continentstobeincluded = [];

    this.aiSourcingService.getCandidateList(requestObject, this.projectNumber).subscribe(
      (response: any) => {
        if (response && response.data) {
          this.showLoaderbeforeDataLoad = false;
          this.archivedProfiles = response.data.results || [];
          this.totalCandidatesCount = response.data.candidatecount || 0;
          if (this.projectDetails?.status === 'inactive') {
            this.blur = true;
            document.body.classList.add('no-scroll');


          }
          this.aiSourcingHandlerService.setProjectCountEvent({ tab: 'archive', count: this.totalCandidatesCount });
          const selectedIds = new Set(this.selectedCandididate.map((c: any) => c.id));
          this.archivedProfiles = (response.data.results || []).map((candidate: any) => ({
            ...candidate,
            selected: selectedIds.has(candidate.id)
          }));

          this.aiSourcingService.emitCandidateListEvent(response.data);

        } else {
          this.showLoaderbeforeDataLoad = false;
          this.archivedProfiles = [];
        }
      },
      (err) => {
        this.showLoaderbeforeDataLoad = false;
        if (err.status == 403) {
          this.showLoaderbeforeDataLoad = false;
          this.archivedProfiles = [];
          if (this.projectDetails?.status == 'inactive') {
            this.doNotshowArchivePage = true;
          }
          if (err.error.errorCode == 'LISTING_BLOCKED') {
            this.reviewpageAccessBlocked = true;
          }
          if (err.error.errorCode == 'AUTOPILOT_ACCESS_DENIED') {
            this.aiSourcingHandlerService.setDisplayPageEvent('landing-page');
            this.router.navigate([`/ai-sourcing`]);
          }
        } else if (err.status == 422) {
          if (err.error.errorCode == 'PROJECT_ACCESS_DENIED') {
            this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
            this.router.navigate([`/ai-sourcing/project-list`]);
          }
        }

      }
    )
  }

  eventHandler(event) {
    if (event.action == 'success') {
      if (event.status == 'shortlist') {
        this.successMessage = 'Candidate successfully shortlisted';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
        this.getArchivedProfiles();
      }
    } else {
      setTimeout(() => {
        if (event && event.data && event.data.currentIndex >= 0) {
          event.data.lastseencount = 1;
          this.archivedProfiles[event.data.currentIndex].lastseencount = 1
        }
      }, 1000)

      var val = event.data.idinindex
      this.archivedProfiles.find(function (item, i) {
        if (item.idinindex === val) {
          index = i;
          return i;
        }
      });

      var index = -1;

      if (event.action == 'append-data' && event.data != undefined && typeof event.data == 'object') {
        // this.candidateList[event.data.currentIndex] = event.data

        var val = event.data.idinindex
        this.archivedProfiles.find(function (item, i) {
          if (item.idinindex === val) {
            index = i;
            return i;
          }
        });

        if (event.data && event.data.existingContactDetails) {
          this.archivedProfiles[index]['existingContactDetails'] = event.data.existingContactDetails;
          this.archivedProfiles[index]['candidatenumber'] = event.data.candidatenumber;
          this.archivedProfiles[index] = Object.assign([], this.archivedProfiles[index]);

        }
        if (event.data && event.data.iswebbtreeverified) {
          this.archivedProfiles[index]['iswebbtreeverified'] = 1;
        }

        if (event.data && event.data.usedWebbtreeIntroduction) {
          this.archivedProfiles[index]['usedWebbtreeIntroduction'] = 1;
        }
        if (event.data && event.data.revealContactAttempted) {
          this.archivedProfiles[index]['revealContactAttempted'] = 1;
        }

      }

      const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');

      if (event.action == 'openNav') {
        //loadn[0].style.display = 'none'
        if (event.type == 'show-contact') {
          this.tabType = 'contactTab'
        } else if (event.type == 'show-activity') {
          this.tabType = 'activityTab'
        } else if (event.type == 'show-skills') {
          this.tabType = 'profileTab'
          this.viewMoreSkills = true;
        }
        else {
          this.tabType = 'autopilotTab'
        }

        if (event.data && event.data.experience && event.data.experience.length && event.data.experience[0].company) {
          const companyObjects = _.pluck(event.data.experience, 'company');
          const payload = companyObjects.map(item => {
            if (item?.id || item?.name) {
              return {
                ...(item?.id && { id: item?.id }),
                ...(item?.name && { name: item?.name })
              }
            }
          }).filter(Boolean);

          this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
            if (res && res.status == "success") {
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = event.data.experience.filter((item) => ((obj.searchedVia === 'id' && obj.key === item.id) || (obj.searchedVia === 'name' && obj.key === item.name)));
                if (matchingObj && matchingObj.length) {
                  let companyLogo = obj.companylogo
                  matchingObj.forEach(x => {
                    x.companylogo = companyLogo;
                  })

                }
              });

              this.openCandidateSlider(index == -1 ? event.data : this.archivedProfiles[index], event.currentIndex)
            } else {
              this.openCandidateSlider(index == -1 ? event.data : this.archivedProfiles[index], event.currentIndex)
            }
          });
        } else {
          this.openCandidateSlider(index == -1 ? event.data : this.archivedProfiles[index], event.currentIndex)
          //loadn[0].style.display = 'none'
        }



      } else if (event.action == 'closeNav') {
        this.closeNav();
      }
    }

    // this.getLastActivity(event.data.idinindex)
  }

  openCandidateSlider(data, currentIndex) {
    this.currentCandidate = data;
    this.currentIndex = data.currentIndex
    this.showCandidate = true;
    document.getElementById("quickView").style.width = "55%";
    document.getElementById("quickView").style.right = "0";
    document.getElementById("overlay").style.display = "block";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
  }

  closeNav() {
    this.viewMoreSkills = false;
    this.showCandidate = false
    document.getElementById("quickView").style.width = "0";
    document.getElementById("overlay").style.display = "none";
    document.getElementById("quickView").style.right = "-50px";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block'
  }

  changeCandidateStatus(data, status) {
    const payload = {
      projectnumber: this.projectNumber,
      status: status,
      elasticids: [data.id],
    }

    this.aiSourcingService.changeCandidateStatus(payload).subscribe((res: any) => {
      if (res.status === 'success') {
        this.successMessage = 'Candidate successfully shortlisted';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
        this.getArchivedProfiles();
      } else {
        this.errorMessage = 'Error occurred while changing candidate status';
        setTimeout(() => {
          this.errorMessage = '';
        }, 5000);
      }
      /**
  * Click on To add to EmailCampaign button
  */
      const archiveParams = {
        "User ID": this.localStorageService.getItem('userdata').userid,
        "Project Number": this.projectNumber,
        "Called From": "Archive Slider",
        "ElasticId": data.id

      }
      clevertap.event.push("Autopilot-Archive Candidate", archiveParams);
    }, (err) => {
      if (err.status === 422) {
        this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
        this.router.navigate([`/ai-sourcing/project-list`]);
      }
    })
  }

  refreshList(res) {
    if (res && res.refresh === true) {
      this.getArchivedProfiles();
    }
  }

  bulkSelectCandidate(res: any) {
    if (res.selectAll == true) {
      this.archivedProfiles.forEach((candidate) => {
        candidate.selected = true;
        this.selectedCandididate.push(candidate);
      });

    } else {
      this.archivedProfiles.forEach((candidate) => {
        candidate.selected = false;
        this.selectedCandididate = this.selectedCandididate.filter(x => x.id !== candidate.id)
      });
    }
    this.aiSourcingService.emitCandidateEvent(this.selectedCandididate);
  };

  selectCandidate(event: any, candidate: any) {
    const value = (event.target as HTMLInputElement) && (event.target as HTMLInputElement).checked ? true : false;
    if (value) {
      candidate.selected = true;
      event.target.checked = true;
      this.selectedCandididate.push(candidate)
    } else {
      candidate.selected = false;
      event.target.checked = false;
      this.selectedCandididate = this.selectedCandididate.filter(x => x.id !== candidate.id);
    }
    this.aiSourcingService.emitCandidateEvent(this.selectedCandididate);
  }

  reEvaluateCriteria() {
    const payload = {
      "projectnumber": this.projectNumber,
      "candidatetype": "archive"
    }
    this.aiSourcingService.reevaluateCriteria(payload).subscribe((res: any) => {
      if (res.status === 'success') {
        this.projectDetails.archivereevaluationstatus = 'started';
        this.aiSourcingHandlerService.setProjectDetails(this.projectDetails);
        this.successMessage = 'Re-evaluation started successfully';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
      }
      else {
        this.errorMessage = 'Error occurred while re-evaluating criteria';
        setTimeout(() => {
          this.errorMessage = '';
        }, 5000);
      }
      /**
        * Click to re-evaluate
        */
      const emailCampaignParams = {
        "User ID": this.localStorageService.getItem('userdata').userid,
        "Project Number": this.projectNumber

      }
      clevertap.event.push("Autopilot-Re-evaluate - Archive Tab", emailCampaignParams);

    })
  }

  getProjectDetails(res) {
    this.projectDetails = res;
    this.showArchiveRevaluate = this.projectDetails?.archivereevaluationstatus;
  }

  setPage(index: number) {
    this.currentPage = index;
    this.getArchivedProfiles();
    this.document.documentElement.scrollTop = 0;

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
